import { render, staticRenderFns } from "./DefectMark.vue?vue&type=template&id=fc8ffeda&scoped=true"
import script from "./DefectMark.vue?vue&type=script&lang=js"
export * from "./DefectMark.vue?vue&type=script&lang=js"
import style0 from "./DefectMark.vue?vue&type=style&index=0&id=fc8ffeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8ffeda",
  null
  
)

export default component.exports